import { render, staticRenderFns } from "./TermCondition.vue?vue&type=template&id=c6a28e60&scoped=true"
import script from "./TermCondition.vue?vue&type=script&lang=js"
export * from "./TermCondition.vue?vue&type=script&lang=js"
import style0 from "./TermCondition.vue?vue&type=style&index=0&id=c6a28e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@6.11.0_webpack@5.104.1__lodash@4_ca1684712bc6b92d0f967ca402105836/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a28e60",
  null
  
)

export default component.exports